import script from "./GrouponCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrouponCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./GrouponCarousel.vue?vue&type=style&index=0&id=9eac6a1a&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eac6a1a"]])

export default __exports__